import { useNavigate } from 'react-router-dom';
import { Lock } from 'lucide-react';

/**
 * CHG-149: 사용자가 멤버가 아닌 조직의 리소스에 접근했을 때 표시되는 안내 화면.
 *
 * - 빈 화면이 아닌 "왜 안 되는지" + "다음에 할 수 있는 일" 명시
 * - 가입 요청 흐름은 본 CHG 범위 외 (별도 후속)
 */
export function OrgAccessDeniedView({ orgName }: { orgName?: string }) {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center justify-center gap-4 py-20 px-4">
      <div className="w-14 h-14 rounded-full bg-gray-100 flex items-center justify-center">
        <Lock className="size-7 text-gray-500" />
      </div>
      <h2 className="text-lg font-semibold text-gray-900">접근 권한이 없습니다</h2>
      <p className="text-sm text-gray-500 max-w-md text-center">
        이 리소스는 {orgName ? <strong className="text-gray-700">{orgName}</strong> : '다른'} 조직에 속하며,
        해당 조직의 멤버가 아닙니다. 조직 관리자에게 초대를 요청해 주세요.
      </p>
      <div className="flex gap-2 mt-2">
        <button
          onClick={() => navigate('/')}
          className="px-4 py-2 bg-primary-600 text-white rounded-lg text-sm font-medium
            hover:bg-primary-700 transition-colors"
        >
          홈으로
        </button>
        <button
          onClick={() => navigate('/projects')}
          className="px-4 py-2 bg-white text-gray-600 border border-gray-200 rounded-lg text-sm font-medium
            hover:bg-gray-50 transition-colors"
        >
          내 프로젝트 목록
        </button>
      </div>
    </div>
  );
}
